module.exports = __webpack_public_path__ + "img/mail_envoi_carte_tp.1e3d3304.svg";